import Menu from 'antd/es/menu';
import styled, { css } from 'styled-components';

export const MenuWrapper = styled.div<{ isMenuOpen: boolean }>`
  background-color: ${({ theme }) => theme.palette.grey1100};
  color: ${({ theme }) => theme.palette.white};
  overflow: hidden;
  transition: opacity 0.25s ease-out, max-height 0.5s ease-out;

  ${({ isMenuOpen }) =>
    isMenuOpen
      ? css`
          opacity: 1;
          max-height: 2000px;
        `
      : css`
          max-height: 0;
          opacity: 0;
        `}
`;

export const MenuItem = styled.div`
  margin-left: 22px;
`;

export const Seperator = styled.div`
  width: calc(100% - 48px);
  height: 1px;
  margin: 16px auto;
  background-color: ${({ theme }) => theme.palette.whiteAlpha200};
`;

export const HeaderReservationsWrapper = styled.div`
  width: 100%;
  padding: 16px 24px 64px 24px;
`;

export const BottomWrapper = styled.div`
  padding: 16px 24px;
`;

export const StyledMobilMenu = styled(Menu)`
  &.setur-menu {
    background: transparent;
    border-inline-end: none !important;
    color: ${({ theme }) => theme.palette.whiteAlpha600};

    .setur-menu-submenu {
      padding-bottom: 0px;
      border-radius: 0px;

      .setur-menu-submenu-title {
        min-height: 56px;
        padding: 16px 24px;
        color: ${({ theme }) => theme.palette.whiteAlpha600} !important;

        &:hover {
          background-color: transparent;
        }
      }
    }

    .setur-menu-title-content {
      color: ${({ theme }) => theme.palette.whiteAlpha600};
      font-family: Montserrat;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
    }
  }
`;
